import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { userActions } from '../actions/user.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class UserEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getUser$ = createEffect(() => {
        return this.actions.pipe(
            ofType(userActions.getUser),
            mergeMap(() => {
                return this.httpService.getUser().pipe(
                    finalizeLoader('user-get'),
                    map((user) => userActions.getUserSuccess({ user })),
                    catchError((response: HttpErrorResponse) => of(userActions.getUserError({ code: response.status }))),
                );
            }),
        );
    });
}
